<!-- <button
class="conditions-button"
(click)="toggle()"
>
<div
  class="conditions-button__toggle"
		[ngClass]="{
    'conditions-button__toggle--open': isOpen,
    'conditions-button__toggle--close': !isOpen
  }"
></div> Условия заключаемых договоров
</button> -->

<section class="conditions">
	<button
		class="conditions-button"
		type="button"
		(click)="onTitleClick()"
	>
		<app-svg-forward-arrow
			class="conditions-button__image"
			width="16px"
			height="16px"
		></app-svg-forward-arrow>
		<div class="conditions-button__toggle"></div>
		Условия заключаемых договоров
	</button>

	<ul class="conditions__list">
		@for (item of conditions; track item) {
			<li class="conditions__list-item">
				<a
					[href]="item.link"
					target="_blank"
				>
					{{ item.name }}
				</a>
			</li>
		}
	</ul>
</section>
